import React from 'react';
import { Link } from 'react-router-dom'
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Checkbox from 'material-ui/Checkbox';
import { Row, Col, Table, PanelGroup, Panel, Button, FormControl, Glyphicon } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'
import MdCheckIcon from 'react-icons/lib/md/check-circle'
import MdModeEdit from 'react-icons/lib/md/mode-edit'
import MdAttachFile from 'react-icons/lib/md/attach-file'	
import MdDone from 'react-icons/lib/md/done'
import MdClose from 'react-icons/lib/md/close'	
import MdToggleIcon from 'react-icons/lib/md/arrow-drop-down-circle'
import _ from 'lodash';
import * as actions from '../../Actions/index.js';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
class AudioVisual extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			job: _.cloneDeep(this.props.job),
			checkParts: true,
			checkPrebuilds: true,
			jobDescEditorState: "",
			costDescription: [],
			partNameToHold:""
		};

		this.toggleSowItem = this.toggleSowItem.bind(this);
		this.toggleAttachment = this.toggleAttachment.bind(this);
		this.togglePart = this.togglePart.bind(this);
		this.discardChanges = this.discardChanges.bind(this);
		this.saveChanges = this.saveChanges.bind(this);
		this.updateInstallation = this.updateInstallation.bind(this);
	}

	editablePartName = (e) => {
		if (e.target.nextElementSibling == null)
			return false;
		e.target.style.display = "none";
		e.target.previousElementSibling.style.display = "none";
		e.target.nextElementSibling.style.display = "flex";
		e.target.nextElementSibling.firstChild.focus();
		this.setState({partNameToHold:e.target.getAttribute('data-partName')})
	}

	updatePartName = (e) => {
		if (e.target.parentNode.previousSibling == null)
			return false;

		if (!this.checkAllPartsIsValid()) {
			e.target.parentNode.previousSibling.style.display = "flex";
			e.target.parentNode.previousSibling.previousSibling.style.display = "flex";
			e.target.parentNode.style.display = "none";
			let job = this.state.job;
			this.props.updatePartNameOFJob(job);
		}

	}

	cancelPartName = (e) => {
		if (e.target.parentNode.previousSibling == null)
			return false;

		e.target.parentNode.previousSibling.style.display = "flex";
		e.target.parentNode.previousSibling.previousSibling.style.display = "flex";
		e.target.parentNode.style.display = "none";
		// console.log(this.state.partNameToHold, e.target.getAttribute('data-key'))
		let job = this.state.job;
		let key = e.target.getAttribute('data-key')
		job.manuals[this.props.manual].parts[key].ItemName = this.state.partNameToHold;
		this.setState({ job: job });
	}

	checkAllPartsIsValid = (e) => {
		let job = this.state.job;
		let error = false;
		if (job.manuals[this.props.manual].parts) {
			_.map(job.manuals[this.props.manual].parts, (part, index) => {
				if (part.ItemName == "" || part.ItemName == null) {
					error = true
				}
			});
		}
		return error
	}

	updatePartValue = (e) => {
		let job = this.state.job;
		let key = e.target.getAttribute('data-key')
		job.manuals[this.props.manual].parts[key].ItemName = e.target.value;
		this.setState({ job: job });
	}

	componentWillReceiveProps(newProps) {
		if (newProps.job !== this.props.job) {
			this.setState({ job: _.cloneDeep(newProps.job) });
		}
	}
	componentDidMount() {
		this.toggleGlobalCheck()
		let sowJobDesc = this.state.job.manuals[this.props.manual]['jobdescription'];
		let sowCostDesc = this.state.job.manuals[this.props.manual]['ctdescription'];

		_.map(sowJobDesc, (item, key) => {
			let HtmlData = item.textHtml
			let changeHtml = HtmlData.replace(/font-family: Roboto, sans-serif;/g, "");
			// console.log(changeHtml);
			if (changeHtml) {
				this.setState({
					jobDescEditorState: changeHtml
				})
				let job = this.state.job;
				if (!_.isEmpty(job.manuals[this.props.manual]['jobdescription'])) {
					job.manuals[this.props.manual]['jobdescription'][0].textHtml = changeHtml;
				}
				this.setState({ job: job });
			}
		})

		_.map(sowCostDesc, (items, value) => {
			// console.log("here is the value",value);
			let HtmlData = items.textHtml
			let changeHtml = HtmlData.replace(/font-family: Roboto, sans-serif;/g, "");
			if (changeHtml) {
				let ctdesc = this.state.costDescription;
				let index = items.costDescNo
				ctdesc[index] = changeHtml
				this.setState({
					costDescription: ctdesc
				})
				// let job = this.state.job;
				// if (!_.isEmpty(job.manuals[this.props.manual]['ctdescription'])) {
				// 	job.manuals[this.props.manual]['ctdescription'][0].textHtml = changeHtml;
				// }
				// this.setState({ job: job });
			}

		});


	}

	HandleJobDescChange = (content, editor) => {
		let job = this.state.job;
		if (!_.isEmpty(job.manuals[this.props.manual]['jobdescription'])) {
			job.manuals[this.props.manual]['jobdescription'][0].textHtml = content;
		}
		this.setState({ job: job });
	}
	HandlecostDescChange = (content, editor) => {
		let job = this.state.job;
		if (!_.isEmpty(job.manuals[this.props.manual]['ctdescription'])) {
			job.manuals[this.props.manual]['ctdescription'][0].textHtml = content;
		}
		this.setState({ job: job });
	}
	discardChanges() {
		this.props.onCancel();
	}
	// handle save changes
	saveChanges() {
		let job = this.state.job;
		if (!this.checkAllPartsIsValid()) {
			job.manuals[this.props.manual].isViewed = true;
			this.props.onSave(job);
		}
	}
	updateInstallation(installation_type) {
		let job = this.state.job;
		job.manuals[this.props.manual].installation_type = installation_type;
		this.setState({ job: job });
	}

	toggleItem(itemType, itemKeyName, itemKeyVal) {
		let job = this.state.job;
		let item = _.find(job.manuals[this.props.manual][itemType], (i) => {
			return i[itemKeyName] === itemKeyVal;
		});
		if (item) {
			item.is_enabled = !item.is_enabled;

			if (itemType === 'ctdescription' && item.is_enabled === false) {
				// item.is_enabled_costName = true;
			}
		}
		this.setState({ job });
	}

	toggleSowItem(itemId) {
		this.toggleItem("sowItems", "ItemID", itemId);
	}
	getDescOfWorks() {

		// let sowItems = this.state.job.manuals[this.props.manual]['sowItems'];

		let items = this.state.job.manuals[this.props.manual]['sowItems'];
		let sowItems = _.filter(items, (item) => {
			return item.ItemType === "Prebuild"
		})

		if (!sowItems || !sowItems.length) {
			return (
				<li>
					No data found.
				</li>
			)
		}

		return _.map(sowItems, (item) => {
			return (
				<li key={`sow-${item.ItemID}`}>
					<Checkbox checked={item.is_enabled} label={item.ItemName} onClick={(e) => { this.toggleSowItem(item.ItemID) }} />
				</li>
			);
		});
	}
	toggleAttachment(fileName) {
		this.toggleItem("attachments", "FileName", fileName);
	}
	getJobDescription() {
		let sowJobDesc = this.state.job.manuals[this.props.manual]['jobdescription'];
		if (!sowJobDesc || !sowJobDesc.length) {
			return (
				<li>
					No Job Description found.
				</li>
			)
		}

		return _.map(sowJobDesc, (item) => {
			// ankit code
			let HtmlData = item.textHtml
			return (
				// <ul className="job-description-data-set">
				// 	<li className="job-description-list" key={`sowJobDesc-${item.type}`}>
				// 		<Checkbox checked={item.is_enabled} onClick={(e) => { this.toggleJobDesc('jobdescription')}}/>
				// 		<div className="job-description-content" dangerouslySetInnerHTML={{__html: HtmlData}}>

				// 		</div>	
				// 	</li>
				// </ul>
				<ul>
					<li>
						<div className="job-description-data-set margl-40">
							<Checkbox checked={item.is_enabled} onClick={(e) => { this.toggleJobDesc('jobdescription') }} />
							<Editor
									apiKey="vmdjvpiknwpg3i3z747i23y6yggjmitl8rdil1995zt3dek3"
									initialValue={this.state.jobDescEditorState}
									init={{
									height: 500,
									menubar: false,
									plugins: [
										'advlist autolink lists link image charmap print preview anchor',
										'searchreplace visualblocks code fullscreen',
										'insertdatetime media table paste code help wordcount'
									],
									toolbar:
										'table | undo redo | bold italic underline strikethrough | subscript superscript | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link ',
									fullpage_default_font_family: "'Century Gothic';",
									plugin_preview_width: 200
									}}
									onEditorChange={this.HandleJobDescChange}
								/>
						</div>
					</li>
				</ul>
			);
		});
	}

	toggleJobDesc(type) {
		this.toggleItem(type, "type", type);
	}
	toggleCostDesc(costDescNo) {
		this.toggleItem("ctdescription", "costDescNo", costDescNo);
	}
	toggleCostDescName(costDescNo) {
		let job = this.state.job;
		let item = _.find(job.manuals[this.props.manual]['ctdescription'], (i) => {
			return i['costDescNo'] === costDescNo;
		});
		if (item) {
			item.is_enabled_costName = !item.is_enabled_costName;

			if (item.is_enabled_costName === true) {
				item.is_enabled = true;
			}
		}
		this.setState({ job });
	}
	getCostCenterDesc() {
		let sowCostDesc = this.state.job.manuals[this.props.manual]['ctdescription'];
		sowCostDesc = _.groupBy(sowCostDesc, 'costDescName');
		if (!sowCostDesc || _.isEmpty(sowCostDesc) == true) {
			return (
				<li>
					No Cost Center Description found.
				</li>
			)
		}

		return _.map(sowCostDesc, (items, value) => {

			let isCostNameEnable = true;
			let costDescNameId;
			let ctdescs = _.map(items, (item, index) => {
				// ankit code
				let HtmlData = item.textHtml
				if (item.is_enabled_costName === false) {
					isCostNameEnable = false;
				}
				costDescNameId = item.costDescNo;
				let ctdesc = this.state.costDescription; 
				return (
					// <ul className="job-description-data-set margl-40">
					// 	<li className="job-description-list" key={`sowJobDesc-${item.costDescNo}`}>
					// 		<Checkbox checked={item.is_enabled} onClick={(e) => { this.toggleCostDesc(item.costDescNo)}}/>
					// 		<div className="job-description-content" dangerouslySetInnerHTML={{__html: HtmlData}}>

					// 		</div>	
					// 	</li>
					// </ul>
					<div className="job-description-data-set margl-40">
						<Checkbox checked={item.is_enabled} onClick={(e) => { this.toggleCostDesc(item.costDescNo) }} />
						<Editor
									apiKey="vmdjvpiknwpg3i3z747i23y6yggjmitl8rdil1995zt3dek3"
									initialValue={ctdesc[costDescNameId]}
									init={{
									height: 500,
									menubar: false,
									plugins: [
										'advlist autolink lists link image charmap print preview anchor',
										'searchreplace visualblocks code fullscreen',
										'insertdatetime media table paste code help wordcount'
									],
									toolbar:
										'table | undo redo | bold italic underline strikethrough | subscript superscript | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link ',
									fullpage_default_font_family: "'Century Gothic'"
									}}
									// onEditorChange={this.HandlecostDescChange}
									onEditorChange = {(content, editor)=>{
										let job = this.state.job;
										if (!_.isEmpty(job.manuals[this.props.manual]['ctdescription'])) {
											_.map(job.manuals[this.props.manual]['ctdescription'], (dataTomodify)=>{
												if(dataTomodify.costDescNo == costDescNameId)
													dataTomodify.textHtml = content
											})
											// job.manuals[this.props.manual]['ctdescription'][0].textHtml = content;
										}
										this.setState({ job: job });
									}}
								/>
					</div>
				);
			});
			return (
				<ul className="job-description-data-set parent-ul cost-center-list">
					<PanelGroup accordion defaultActiveKey='1'>
						<Checkbox className="cost-center-checkbox" checked={isCostNameEnable} onClick={(e) => { this.toggleCostDescName(costDescNameId) }} />
						<Panel eventKey='0'>
							<Panel.Heading>
								<Panel.Title toggle>
									<li className="job-heading" key={`sowJobDesc-${value}`}>
										<div className="job-description-content">
											{value}
										</div>

									</li>
								</Panel.Title>
							</Panel.Heading>
							<Panel.Body collapsible>
								{ctdescs}
							</Panel.Body>
						</Panel>

					</PanelGroup>
				</ul>
			);
		});
	}

	getAttachments() {
		let attachments = this.state.job.manuals[this.props.manual]['attachments'];

		if (!attachments || !attachments.length) {
			return (
				<li>
					No attachments found.
				</li>
			)
		}

		return _.map(attachments, (item) => {
			return (
				<li key={`attachment-${item.FileName}`}>
					<Checkbox checked={item.is_enabled} label={item.FileName}
						onClick={(e) => { this.toggleAttachment(item.FileName) }} />
				</li>

			);
		});
	}

	togglePart(stockItemId) {
		this.toggleItem("parts", "StockItemID", stockItemId);
		this.toggleAllPartAttachment(stockItemId);
	}

	toggleAllPartAttachment = (stockItemId) => {
		let job = this.state.job;
		let item = _.find(job.manuals[this.props.manual].parts, (i) => {
			// console.log(i);
			return i.StockItemID === stockItemId;
		});
		_.map(item.attachment_key, (i) => {
			i.is_enabled = item.is_enabled;
		});
		this.toggleGlobalCheck(stockItemId);
		this.setState({ job });
	}

	togglePartAttachment(itemKeyName, itemKeyVal) {
		let job = this.state.job;
		let item = _.find(job.manuals[this.props.manual]['parts'], (i) => {
			return _.find(i.attachment_key, (link_obj) => {
				return link_obj.file_name === itemKeyVal;
			})
		});
		if (item) {
			item.attachment_key[itemKeyName].is_enabled = !item.attachment_key[itemKeyName].is_enabled;
		}
		// _.map(job.manuals[this.props.manual]['parts'], (i) => {
		// 	let all_enable = false;
		// 	let attachment = _.map(i.attachment_key, (link_obj) => {
		// 		if (link_obj.is_enabled === true)
		// 			all_enable = true;
		// 	})
		// 	i.is_enabled = all_enable;
		// })
		this.toggleGlobalCheck();
		this.setState({ job });
	}

	toggleGlobalCheck = () => {
		let job = this.state.job;
		let toggleValue = true
		_.map(job.manuals[this.props.manual].parts, (i) => {
			if (i.is_enabled === false) {
				toggleValue = false;
			}
		});
		this.setState({ checkParts: toggleValue });
		this.setState({ job });
	}

	toggleAllPart = (itemType) => {
		let job = this.state.job;
		job.manuals[this.props.manual][itemType].map((data, i) => {
			data.is_enabled = !this.state.checkParts;
			if (!_.isEmpty(data.attachment_key)) {
				data.attachment_key.map((item) => {
					item.is_enabled = !this.state.checkParts;
				});
			}
		});
		//  this.setState({checkParts: true});
		this.setState({ checkParts: !this.state.checkParts })
		this.setState({ job });
	}
	toggleAllPrebuild = (itemType) => {
		let job = this.state.job;
		job.manuals[this.props.manual][itemType].map((data, i) => {
			data.is_enabled = !this.state.checkPrebuilds
		});
		this.setState({ checkPrebuilds: !this.state.checkPrebuilds })
		this.setState({ job });
	}

	getListOfParts() {
		let parts = this.state.job.manuals[this.props.manual]['parts'];

		if (!parts || !parts.length) {
			return (
				<li>
					No parts found.
				</li>
			)
		}
		return _.map(parts, (item, key) => {
			let partName = <div className="inline-title">
				{
					<span className="attach-icon">
						<span style={{ display: 'inline-block' }}>{item.ItemName}</span>
						<Button  onClick={this.editablePartName} data-partName={item.ItemName}><MdModeEdit /></Button>
						<span style={{ display: "none", width: "100%", alignItems:'center' }} className="update-section">
							<FormControl
								type="text"
								value={item.ItemName}
								data-key={key}
								onChange={this.updatePartValue}
								className="update-value"
							/>
							{/* <input type="text" value={item.ItemName} onChange={this.updatePartValue} data-key={key} required style={{display: 'inline-block'}}/> */}
							<Button className="update-btn" onClick={this.updatePartName}><MdDone /></Button>
							<Button className="update-btn cancel-btn" onClick={this.cancelPartName} data-key={key}><MdClose /></Button>
							{item.ItemName ? "" : "Required Field"}
						</span>
					</span>
				}
			</div>;

			let items_key = _.map(item.attachment_key, (i, key) => {
				// console.log(item.StockItemID+key.toString());
				return <Checkbox checked={i.is_enabled} label={i.file_name}
					onClick={(e) => { this.togglePartAttachment(key, i.file_name) }} />
			});
			//let is_enabled_group = this.state.job.manuals[this.props.manual].parts[key].is_enabled;
			return (
				<li key={`part-${item.StockItemID}`}>
					{/* <Checkbox checked={item.is_enabled} label={partName}
							onClick={(e) => { this.togglePart(item.StockItemID)}}/> */}

					<Panel key={`${item.StockItemID}`} eventKey={`template-group-${partName}`} style={{ marginBottom: 0 }}>
						<Panel.Heading>
							{/* {items_key.length > 0 ? */}
								<Checkbox checked={item.is_enabled}
									// label={is_enabled_group ? <span>Deselect all</span>: <span>Select all</span>}
									label={partName}
									onClick={(e) => { this.togglePart(item.StockItemID) }} />

								{/* : <Checkbox checked={false}
								// label={is_enabled_group ? <span>Deselect all</span>: <span>Select all</span>}
								label={partName}
								onClick={(e) => { this.togglePart(item.StockItemID) }} disabled={true}/>} */}
							<div className="left-wrap">		
							<p className="total-attachment"><MdAttachFile /> ({items_key.length})</p>
							{items_key.length ?
							<Panel.Title className="inline-title" toggle>
									<span className="drop-toggle-btn">
										<span></span>
										{/* <MdToggleIcon color="#3c763d"/> */}
									</span>
							</Panel.Title>: <Panel.Title className="inline-title no-data" >
									<span className="drop-toggle-btn">
										<span></span>
										{/* <MdToggleIcon color="#3c763d"/> */}
									</span>
							</Panel.Title>}
							</div>
						</Panel.Heading>
						<Panel.Body collapsible >
							<div className="dashboard-table-data">
								<table width="100%">
									<tbody>
										{items_key}
									</tbody>
								</table>
							</div>
						</Panel.Body>
					</Panel>
				</li>
			);
		});
	}

	render() {
		if (!this.props.job || !this.state.job.manuals[this.props.manual]) {
			window.location = '/job';
			return null; // TODO: Return a loading indicator
		}
		let compName = this.props.currentuser.company ? this.props.currentuser.company.name : '';
		let jobid = this.props.job.simpro_id;
		let descOfWorks = this.getDescOfWorks();

		let attachments = this.getAttachments();
		let listOfParts = this.getListOfParts();
		let jobDesc = this.getJobDescription();
		let costCenterDesc = this.getCostCenterDesc();
		let instal_type = this.state.job.manuals[this.props.manual].installation_type;

		return (<div>

			<div className="dashboard-page">
				<div className="right-content-dashboard active-dashboard">
					<div className="audio-visual-content">
						<div className="top-heading">
							<div className="back-button-heading">
								<h2><Link to={`/job/${jobid}`}><MdArrowBack /></Link> <span>JOB #{this.props.job.simpro_id}</span> {this.props.manual}</h2>
							</div>
							<div className="right-job-id">
								<label>
									<Link to="#">

									</Link>
								</label>
							</div>
						</div>
						<div className="audio-visual-list">
							<h3>Installation</h3>
							<ul>
								<li>
									<RadioButtonGroup name="shipSpeed" defaultSelected={instal_type ? instal_type : null}>
										<RadioButton
											value='self'
											onClick={(e) => { this.updateInstallation('self') }}
											label={`System installed by ${compName}.`}
										/>
										<RadioButton
											value="third-party"
											onClick={(e) => { this.updateInstallation('third-party') }}
											label="Existing system installed previously by third party."
										/>
									</RadioButtonGroup>
								</li>
							</ul>
						</div>
						<div className="clearfix"></div>
						<div className="audio-visual-list">
							<h3>Scope Of Works</h3>
							<ul>
								<div className="wrap-white-back">
									<h3>Pre-builds</h3>
									<li>
										<div>
											<Checkbox checked={this.state.checkPrebuilds}
												onClick={(e) => { this.toggleAllPrebuild('sowItems') }}
												label={this.state.checkPrebuilds ? <span>Deselect all</span> : <span>Select all</span>}
											/>

										</div>

									</li>
									{descOfWorks}
									<h3>Job Description</h3>
									{jobDesc}
									<h3>Cost Centres</h3>
									{costCenterDesc}
								</div>
							</ul>

						</div>
						<div className="clearfix"></div>
						<div className="audio-visual-list">
							<h3>Attachments</h3>
							<ul>
								{attachments}
							</ul>
						</div>
						<div className="clearfix"></div>
						<div className="audio-visual-list margb20px audio-visual-list-item">
							<h3>Stock parts</h3>
							<ul>
								<li>
									<div>
										<Checkbox
											checked={this.state.checkParts}
											onClick={(e) => { this.toggleAllPart('parts') }}
											label={this.state.checkParts ? <span>Deselect all</span> : <span>Select all</span>}
										/>
									</div>
								</li>
								{listOfParts}
							</ul>
						</div>

						<div className="clearfix"></div>
						<Row className="display-flex audio-bottom-buttons" style={{ padding: '10px' }}>
							<Col md={6}>
								<FlatButton
									label="Discard Changes"
									labelStyle={{ 'fontWeight': '600', color: '#e94731' }}
									icon={<MdDelete color="#e94731" />}
									onClick={this.discardChanges}
								/>
							</Col>
							<Col md={6}>
								<div className="forgotten-password">
									<RaisedButton
										label="Save"
										type="submit"
										labelColor="#fff"
										labelStyle={{ 'fontWeight': '500' }}
										fullWidth={false}
										onClick={this.saveChanges}
									/>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>
		)
	}
}



const mapStateToProps = (state, props) => {
	return {
		currentuser: state.login,
	};
}
export default connect(mapStateToProps, actions)(AudioVisual);


// WEBPACK FOOTER //
// ./src/Components/Pages/AudioVisual.js